import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      'Language changed': 'Language changed',
      'Your view': 'Your view',
      'General': 'General',
      'Overview': 'Overview',
      'Analytics': 'Analytics',
      'Finance': 'Finance',
      'Logistics': 'Logistics',
      'Account': 'Account',
      'Contacts': 'Contacts',
      'Customers': 'Customers',
      'List': 'List',
      'Details': 'Details',
      'Edit': 'Edit',
      'Products': 'Products',
      'Create': 'Schaffen',
      'Orders': 'Aufträge',
      'Invoices': 'Rechnungen',
      'Platforms': 'Plattform',
      'Job Listings': 'Stellenangebote',
      'Browse': 'Durchsuche',
      'Social Media': 'Sozialen Medien',
      'Profile': 'Profil',
      'Feed': 'Füttern',
      'Blog': 'Blog',
      'Post List': 'Beitragsliste',
      'Post Details': 'Beitragsdetails',
      'Post Create': 'Beitrag erstellen',
      'Apps': 'Apps',
      'Kanban': 'Kanban',
      'Mail': 'E-Mail',
      'Chat': 'Plaudern',
      'Calendar': 'Kalender',
      'Pages': 'Seiten',
      'Auth': 'Authentifizierung',
      'Register': 'Registrieren',
      'Login': 'Anmeldung',
      'Pricing': 'Preisgestaltung',
      'Checkout': 'Auschecken',
      'Contact': 'Kontakt',
      'Error': 'Fehler',
      'Need Help?': 'Brauchen Sie Hilfe?',
      'Contact support': 'Überprüfen Sie unsere Dokumente',
      'Documentation': 'Dokumentation'
    }
  },
  es: {
    translation: {
      'Language changed': 'Se ha cambiado el idioma.',
      'Your view': 'Tu vista',
      'General': 'General',
      'Overview': 'Vista general',
      'Analytics': 'Analítica',
      'Finance': 'Finanzas',
      'Logistics': 'Logística',
      'Account': 'Cuenta',
      'Contacts': 'Contactos',
      'Customers': 'Contactos',
      'List': 'Lista',
      'Details': 'Detalles',
      'Edit': 'Editar',
      'Products': 'Productos',
      'Create': 'Crear',
      'Orders': 'Pedidos',
      'Invoices': 'Facturas',
      'Platforms': 'Plataforma',
      'Job Listings': 'Listado de trabajos',
      'Browse': 'Buscar',
      'Social Media': 'Redes sociales',
      'Profile': 'Perfil',
      'Feed': 'Fuente social',
      'Blog': 'Blog',
      'Post List': 'Lista de articulos',
      'Post Details': 'Detalles del articulo',
      'Post Create': 'Create articulo',
      'Apps': 'Aplicaciones',
      'Kanban': 'Kanban',
      'Mail': 'Correo',
      'Chat': 'Chat',
      'Calendar': 'Calendario',
      'Pages': 'Páginas',
      'Auth': 'Autenticación',
      'Register': 'Registrarse',
      'Login': 'Acceso',
      'Pricing': 'Precios',
      'Checkout': 'Pago',
      'Contact': 'Contacto',
      'Error': 'Error',
      'Need Help?': '¿Necesitas ayuda?',
      'Contact support': 'Contacta al soporte',
      'Support': 'Soporte'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });
